export enum InsightTypes {
  CONVERSION_INFLUENCE = 'ConversionInfluence'
}
